import './index.css';
import React from 'react';
import { isMobileBrowser } from '../../utilities/helper';
import { CSSProperties } from 'react';
import { View as RRSView } from 'react-router-stack';

interface Props {
  children?: object;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  backgroundColor?: string;
}

const RouteWrapper = ({ children, className, backgroundColor }: Props) => {
  return (
    <RRSView
      style={{ backgroundColor }}
      type={'ACTIVE'}
      className={
        isMobileBrowser ? 'route-mobile-stack-wrapper' : 'route-web-stack-wrapper ' + className
      }>
      {children}
    </RRSView>
  );
};

export default React.memo(RouteWrapper);
